module.exports = __webpack_public_path__ + "img/bg-effect.76f91b7e.png";